import React from 'react';
import { formatCurrency } from '../../lib/helpers/formatters';

const TotalTr = ({ data = [], stickyInfo = [], children = [] } = {}) => {
  if (!Array.isArray(data)) return null;

  const totals = data.reduce(
    (acc, row = {}) => {
      const {
        gross = 0,
        net = 0,
        extraShare = 0,
        payments = [],
        adminShare = 0,
        billableAdminShare = 0,
        earnedAdminShare = 0,
        commercialShare = 0,
        billableCommercialShare = 0,
        earnedCommercialShare = 0,
        commercial = {},
        commercial2 = {},
        commercial3 = {},
      } = row;
      const reducedPayments = payments.reduce(
        (acc, { gross } = {}) => acc + (gross || 0),
        0
      );
      return {
        gross: acc.gross + gross,
        net: acc.net + net,
        extraShare: acc.extraShare + extraShare,
        payments: acc.payments + reducedPayments,
        adminShares: acc.adminShares + adminShare,
        adminBillable: acc.adminBillable + billableAdminShare,
        earnedAdminShares: acc.earnedAdminShares + earnedAdminShare,
        commercialShare: acc.commercialShare + commercialShare,
        billableCommercialShare:
          acc.billableCommercialShare + billableCommercialShare,
        earnedCommercialShare:
          acc.earnedCommercialShare + earnedCommercialShare,

        commercial1Share: acc.commercial1Share + (commercial.share || 0),
        commercial1Earned:
          acc.commercial1Earned + (commercial.earnedShare || 0),
        commercial1Billable:
          acc.commercial1Billable + (commercial.billableShare || 0),

        commercial2Share: acc.commercial2Share + (commercial2.share || 0),
        commercial2Earned:
          acc.commercial2Earned + (commercial2.earnedShare || 0),
        commercial2Billable:
          acc.commercial2Billable + (commercial2.billableShare || 0),

        commercial3Share: acc.commercial3Share + (commercial3.share || 0),
        commercial3Earned:
          acc.commercial3Earned + (commercial3.earnedShare || 0),
        commercial3Billable:
          acc.commercial3Billable + (commercial3.billableShare || 0),
      };
    },
    {
      gross: 0,
      net: 0,
      extraShare: 0,
      payments: 0,
      adminShares: 0,
      adminBillable: 0,
      earnedAdminShares: 0,
      commercialShare: 0,
      billableCommercialShare: 0,
      earnedCommercialShare: 0,
      commercial1Share: 0,
      commercial1Earned: 0,
      commercial1Billable: 0,
      commercial2Share: 0,
      commercial2Earned: 0,
      commercial2Billable: 0,
      commercial3Share: 0,
      commercial3Earned: 0,
      commercial3Billable: 0,
    }
  );

  const cells = [
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    formatCurrency(totals.net),
    formatCurrency(totals.gross),
    formatCurrency(totals.payments),
    formatCurrency(totals.extraShare),
    formatCurrency(totals.adminShares),
    formatCurrency(totals.earnedAdminShares),
    formatCurrency(totals.adminBillable),
    formatCurrency(totals.commercial1Share),
    formatCurrency(totals.commercial1Earned),
    formatCurrency(totals.commercial1Billable),
    formatCurrency(totals.commercial2Share),
    formatCurrency(totals.commercial2Earned),
    formatCurrency(totals.commercial2Billable),
    formatCurrency(totals.commercial3Share),
    formatCurrency(totals.commercial3Earned),
    formatCurrency(totals.commercial3Billable),
    '-',
    '-',
    '-',
  ];

  return (
    <tr className="summary-tr">
      {children.map((child, idx) => {
        const isSticky = child?.props?.sticky;
        const style = stickyInfo?.[idx]?.style || {};
        return (
          <td
            key={idx}
            className={isSticky ? 'sticky' : undefined}
            style={isSticky ? style : undefined}
          >
            {cells[idx] !== undefined ? cells[idx] : '-'}
          </td>
        );
      })}
    </tr>
  );
};

export default TotalTr;
